import React, { useEffect, useState } from "react";
import { api } from "../../../software/api";
import { toast } from "sonner";
import { Bot } from "lucide-react";

// Admin switch: let the app create invoice / booked work-order reminders, or keep every reminder manual.
export const AutoRemindersToggle = ({ isAdmin, onChanged }) => {
  const [st, setSt] = useState(null);
  useEffect(() => { api("GET", "/settings/auto-reminders").then(setSt).catch(() => {}); }, []);
  if (!st) return null;
  const flip = async () => {
    const enabled = !st.enabled;
    let remove_existing = false;
    if (!enabled && st.open_auto > 0) remove_existing = window.confirm(`Auto reminders will be switched OFF.\n\nAlso delete the ${st.open_auto} open reminder(s) the app already created (invoice chase / booked work order)?\n\nOK = delete them · Cancel = keep them`);
    const r = await api("PUT", "/settings/auto-reminders", { enabled, remove_existing });
    toast.success(enabled ? "Auto reminders ON" : `Auto reminders OFF${r.removed ? ` — removed ${r.removed}` : ""}`);
    setSt({ enabled, open_auto: remove_existing ? 0 : st.open_auto });
    onChanged && onChanged();
  };
  return (
    <button onClick={isAdmin ? flip : undefined} disabled={!isAdmin} data-testid="auto-reminders-toggle"
      title={isAdmin ? "Let the app create invoice-chase and booked work-order reminders automatically" : "Only an admin can change this"}
      className={`inline-flex items-center gap-1.5 rounded-full border-2 px-3 py-1.5 mb-4 text-xs font-bold transition-colors ${st.enabled ? "border-emerald-300 bg-emerald-50 text-emerald-700" : "border-slate-300 bg-white text-slate-500"} ${isAdmin ? "hover:brightness-95" : "cursor-not-allowed"}`}>
      <Bot className="h-4 w-4" />Auto reminders: <span data-testid="auto-reminders-state">{st.enabled ? "ON" : "OFF"}</span>
    </button>
  );
};
